// extracted by mini-css-extract-plugin
export default {"headerBar":"eJ-z","pointsSection":"fJ-z","goToDashboard":"gJ-z"};